import {
  ADD_LEAD_START,
  ADD_LEAD_SUCCESS,
  ADD_LEAD_FAILURE,
  ADD_LEAD_RESET,
  GET_LEAD_START,
  GET_LEAD_SUCCESS,
  GET_LEAD_FAILURE,
  GET_LEAD_RESET,
  DELETE_LEAD_START,
  DELETE_LEAD_SUCCESS,
  DELETE_LEAD_FAILURE,
  DELETE_LEAD_RESET,
  EDIT_LEAD_FAILURE,
  EDIT_LEAD_RESET,
  EDIT_LEAD_START,
  EDIT_LEAD_SUCCESS,
  VIEW_LEAD_START,
  VIEW_LEAD_SUCCESS,
  VIEW_LEAD_FAILURE,
  VIEW_LEAD_RESET,
  CREATE_LEADLOG_START,
  CREATE_LEADLOG_SUCCESS,
  CREATE_LEADLOG_FAILURE,
  CREATE_LEADLOG_RESET,
  CONVERT_LEAD_START,
  CONVERT_LEAD_SUCCESS,
  CONVERT_LEAD_ERROR,
  CLOSE_LEAD_START,
  CLOSE_LEAD_SUCCESS,
  CLOSE_LEAD_FAILURE,
  GET_CLOSELEAD_REASON_START,
  GET_CLOSELEAD_REASON_SUCCESS,
  GET_CLOSELEAD_REASON_FAILURE,
  GET_CLOSELEAD_REASON_RESET,
  GET_BLOCKED_LEAD_START,
  GET_BLOCKED_LEAD_FAILURE,
  GET_BLOCKED_LEAD_RESET,
  GET_BLOCKED_LEAD_SUCCESS,
} from "./actiontypes"

const initialState = {
  leads: [],
  closeLeads: [],
  loading: false,
  viewLead: [],
  error: null,
  AddLeadLoading: false,
  leadMsg: "",
  deletelead: false,
  deleteleadMsg: "",
  editLeadLoading: false,
  AddLogLoading: false,
  logMsg: "",
  cid: "",
  createLog: [],
  logs: [],
  isBulkUpdated: false,
  leadLog: [],
  loading: false,
  closeleadreasons: [],
}

const leadReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LEAD_START:
      return {
        ...state,
        AddLeadLoading: true,
        error: null,
        leadMsg: null,
      }
    case ADD_LEAD_SUCCESS:
      // console.log(action.payload)
      return {
        ...state,
        leadMsg: action.payload.message,
        AddLeadLoading: false,
      }
    case ADD_LEAD_FAILURE:
      return {
        ...state,
        error: action.payload.message,
        AddLeadLoading: false,
      }
    case ADD_LEAD_RESET:
      return {
        leads: [],
        error: null,
        AddLeadLoading: false,
        leadMsg: "",
      }

    case GET_LEAD_START:
      return {
        ...state,
        AddLeadLoading: true,
        error: null,
        leadMsg: "",
      }

    case GET_LEAD_SUCCESS:
      return {
        ...state,
        AddLeadLoading: false,
        leads: action.payload.data,
      }

    case GET_LEAD_FAILURE:
      return {
        ...state,
        AddLeadLoading: false,
        error: action.payload.message,
      }
    case GET_LEAD_RESET:
      return {
        leads: [],
        error: null,
        AddLeadLoading: false,
        leadMsg: "",
      }

    // for delete

    case DELETE_LEAD_START:
      return {
        ...state,
        deletelead: true,
        error: null,
        deleteleadMsg: "",
      }
    case DELETE_LEAD_SUCCESS:
      return {
        ...state,
        deletelead: false,
        error: null,
        deleteleadMsg: action.payload.message,
      }
    case DELETE_LEAD_FAILURE:
      return {
        ...state,
        deletelead: false,
        error: action.payload,
      }
    case DELETE_LEAD_RESET:
      return {
        leads: [],
        ...state,
        deletelead: false,
        error: null,
        deleteleadMsg: "",
      }

    case EDIT_LEAD_START:
      return {
        ...state,
        error: null,
        editLeadLoading: true,
        leadMsg: "",
      }
    case EDIT_LEAD_SUCCESS:
      return {
        ...state,
        error: null,
        editLeadLoading: false,
        leadMsg: action.payload.message,
      }
    case EDIT_LEAD_FAILURE:
      return {
        ...state,
        editLeadLoading: false,
        error: action.payload.message,
      }
    case EDIT_LEAD_RESET:
      return {
        error: null,
        AddLeadLoading: false,
        leadMsg: "",
        deletelead: false,
        deleteleadMsg: "",
        editLeadLoading: false,
      }
    //View-Lead
    case VIEW_LEAD_START:
      return {
        ...state,
        AddLeadLoading: true,
        error: null,
        leadMsg: "",
      }

    case VIEW_LEAD_SUCCESS:
      return {
        ...state,
        AddLeadLoading: false,
        viewLead: action.payload.LeadData,
        leadLog: action.payload.Logdata,
      }

    case VIEW_LEAD_FAILURE:
      return {
        ...state,
        AddLeadLoading: false,
        error: action.payload.message,
      }
    case VIEW_LEAD_RESET:
      return {
        leads: [],
        error: null,
        AddLeadLoading: false,
        leadMsg: "",
      }

    //create lead log
    case CREATE_LEADLOG_START:
      return {
        ...state,
        AddLogLoading: true,
        error: null,
        logMsg: "",
      }

    case CREATE_LEADLOG_SUCCESS:
      return {
        ...state,
        AddLogLoading: false,
        createLog: action.payload.data,
      }

    case CREATE_LEADLOG_FAILURE:
      return {
        ...state,
        AddLogLoading: false,
        error: action.payload.message,
      }
    case CREATE_LEADLOG_RESET:
      return {
        logs: [],
        error: null,
        AddLogLoading: false,
        logMsg: "",
      }
    case CONVERT_LEAD_START:
      return {
        ...state,
        loading: true,
        error: false,
        leadMsg: "",
      }
    case CONVERT_LEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        leadMsg: action.payload.message,
        cid: action.payload.c_id,
      }
    case CONVERT_LEAD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case CLOSE_LEAD_START:
      return {
        ...state,
        loading: true,
        error: false,
        leadMsg: "",
      }
    case CLOSE_LEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        leadMsg: action.payload.message,
      }
    case CLOSE_LEAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }
    // get close lead reasons

    case GET_CLOSELEAD_REASON_START:
      return {
        ...state,
      }

    case GET_CLOSELEAD_REASON_SUCCESS:
      console.log(action.payload.data)
      return {
        ...state,
        closeleadreasons: action.payload.data,
      }

    case GET_CLOSELEAD_REASON_FAILURE:
      return {
        ...state,
      }
    case GET_CLOSELEAD_REASON_RESET:
      return {
        closeleadreasons: [],
      }
    case GET_BLOCKED_LEAD_START:
      return {
        ...state,
        loading: true,
        errror: null,
      }
    case GET_BLOCKED_LEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        closeLeads: action.payload,
        errror: null,
      }

    case GET_BLOCKED_LEAD_FAILURE:
      return {
        ...state,
        loading: false,
        errror: action.payload.data,
      }

    case GET_BLOCKED_LEAD_RESET:
      return {
        ...state,
        loading: false,
        errror: null,
        closeLeads: [],
      }

    default:
      return state
  }
}

export default leadReducer
